// extracted by mini-css-extract-plugin
export default {"root":"Note_root__t1JwJ","content":"Note_content__8Scp-","action":"Note_action__Uvrhm"};